'use client';
import { useState, useEffect } from 'react';
import { browserAction, isBrowser } from '@s7/platform';
import { isNumber } from '@s7/utils';
import { useWindowEvent } from '../useWindowEvent/useWindowEvent.js';

const getScrollPosition = ()=>{
    return isBrowser ? {
        x: window.scrollX,
        y: window.scrollY
    } : {
        x: 0,
        y: 0
    };
};
const scrollTo = browserAction(({ x, y })=>{
    const scrollOptions = {
        behavior: 'smooth'
    };
    if (isNumber(x)) {
        scrollOptions.left = x;
    }
    if (isNumber(y)) {
        scrollOptions.top = y;
    }
    window.scrollTo(scrollOptions);
});
const useWindowScroll = ()=>{
    const [position, setPosition] = useState({
        x: 0,
        y: 0
    });
    useWindowEvent('scroll', ()=>setPosition(getScrollPosition()));
    useWindowEvent('resize', ()=>setPosition(getScrollPosition()));
    useEffect(()=>{
        setPosition(getScrollPosition());
    }, []);
    return [
        position,
        scrollTo
    ];
};

export { scrollTo, useWindowScroll };
//# sourceMappingURL=useWindowScroll.js.map
